import * as THREE from 'three'

import EventEmitter from './Utils/EventEmitter.js'
import Loader from './Utils/Loader.js'

export default class Resources extends EventEmitter
{
    constructor()
    {
        super()
        this.items = {}
        this.loader = new Loader()

        const matcaps = ['beige', 'black', 'blue', 'brown', 'copperMetal', 'emeraldGreen', 'goldMetal', 'gray', 'green', 'metal', 'orange', 'purple', 'red', 'white', 'yellow']
        const resources = matcaps.map((_name) => ({
            name: `matcap${_name[0].toUpperCase()}${_name.slice(1)}`,
            source: `/models/matcaps/${_name}.png`,
            type: 'texture'
        }))

        resources.push(
            { name: 'introStaticBase', source: '/models/intro/static/base.glb' },
            { name: 'informationStaticBase', source: '/models/information/static/base.glb' },
            { name: 'woodHit', source: '/sounds/wood-hits/wood-hit-1.mp3' },
            { name: 'reveal', source: '/sounds/reveal/reveal-1.mp3' },
            { name: 'area', source: '/sounds/ui/area-1.mp3' }
        )

        this.loader.on('fileEnd', (_resource, _data) =>
        {
            this.items[_resource.name] = _data
            if(_resource.type === 'texture')
            {
                const texture = new THREE.Texture(_data)
                texture.colorSpace = THREE.SRGBColorSpace
                texture.needsUpdate = true
                this.items[`${_resource.name}Texture`] = texture
            }
            this.trigger('progress', [this.loader.loaded / this.loader.toLoad])
        })
        this.loader.on('end', () => this.trigger('ready'))
        this.loader.load(resources)
    }
}
